import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import FormHelper from 'helpers/FormHelper';
import FileList from '../../../../../../../components/fileList/index.';
import { Descriptions } from 'antd';

const ImagesSection = ({
  isEdit,
  singleItem,
  updateInProcess,
  handleDeleteFile,
  isView,
}) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Files')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Logo')}>
          <Form.Item
            name='logo'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              disabled={isView}
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'JPG', 'PNG', 'SVG'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={`${t('Formati accettati')}:`}>
              JPG PNG SVG
            </Descriptions.Item>
            <Descriptions.Item label={`${t('Dimensione massima')}:`}>
              5MB
            </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.allData?.logo
                  ? [
                      {
                        file: {
                          url: singleItem?.allData?.logo,
                          file_name: singleItem?.allData?.logo_name || 'name',
                          id: singleItem?.allData?.logo_id || 'id',
                        },
                        image_id: singleItem?.allData?.logo_id,
                        param: 'logo',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Header Immagine')}>
          <Form.Item
            name='header_images'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={true}
          >
            <Upload.Dragger
              disabled={isView}
              multiple={true}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'JPG', 'PNG', 'SVG'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={`${t('Formati accettati')}:`}>
              JPG PNG SVG
            </Descriptions.Item>
            <Descriptions.Item label={`${t('Dimensione massima')}:`}>
              5MB
            </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.allData?.header_images
                  ? singleItem?.allData?.header_images.map((i) => ({
                      file: {
                        url: i.url,
                        file_name: i.filename,
                        id: i.id,
                      },
                      image_id: i.id,
                      param: 'header_images',
                    }))
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col span={0}>
        {/* <Form.Item label={t('Offerte header image')}>
          <Form.Item
            name='header_image_offers'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              disabled={isView}
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'JPG', 'PNG', 'SVG'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  JPG PNG SVG
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  5MB
                  </Descriptions.Item>
            </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.allData?.header_image_offers
                  ? [
                      {
                        file: {
                          url: singleItem.allData.header_image_offers,
                          file_name: singleItem.allData.header_image_offers_name || 'name',
                          id: singleItem.allData.header_image_offers_id || 'id',
                        },
                        image_id: singleItem.allData.header_image_offers_id,
                        param: 'header_image_offers',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row> */}
      </Col>
    </Row>
  );
};

export default React.memo(ImagesSection);
